import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb/breadcrumb.service';
import { BreadcrumbViewModel } from '../../models/view/breadcrumb';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

    model: BreadcrumbViewModel[];

    constructor(private breadcrumbService: BreadcrumbService) {
        this.model = this.breadcrumbService.get();
    }

    ngOnInit() {
    }

}
